export default {
    threeCrossSave: '/index.php/cqh/Threeproject/save',//实施计划报备表保存
    threeCrossList: '/index.php/cqh/Threeproject/lists',//三交项目实施计划报备列表
    threeCrossDel: '/index.php/cqh/Threeproject/delete',//删除实施计划表
    reportState: '/index.php/cqh/Threeproject/report_state',//各县填报情况
    threeCrossStatic: '/index.php/cqh/Threeproject/report_statistics',//三交项目实施情况汇总
    threeCrossStaticReport: '/index.php/cqh/Threeproject/report_statistics_out',//三交项目实施情况汇总导出
    threeCrossReport: '/index.php/cqh/Threeproject/lists_out',//三交项目实施计划报备列表导出
};